import {
    GroupedComboBoxRenderIcon,
    GroupedComboBoxRenderLabel,
    IGroupedComboBoxItem,
    IGroupedComboBoxSubMenuSection,
} from 'grouped-combobox-core';
import { fontInfoItemKey } from '../../common/constants';
import { IInternalFontVariant } from '../../common/internalFont';
import { createPinnedVariantItem } from '../../common/variantSection';
import { IFontFamily, IStringResources } from '../FontPicker.types.shared';
import { emptyIconProps } from '../../common/iconNames';

export function createFontVariantSubmenu(
    font: IFontFamily,
    canPin: boolean,
    pinnedFontKeys: string[],
    stringResources: IStringResources,
    renderPreviewFont: GroupedComboBoxRenderLabel | undefined,
    onRenderIcon: GroupedComboBoxRenderIcon | undefined,
    allowFontInfoPane: boolean
): IGroupedComboBoxSubMenuSection[] | undefined {
    const { submenu } = font;

    if (!submenu) {
        return undefined;
    }

    const pinnedItems: IGroupedComboBoxItem[] = [];

    const sections: IGroupedComboBoxSubMenuSection[] = [
        {
            items: pinnedItems,
        },
        {
            sortByOrder: true,
            items: submenu.variants.map<IGroupedComboBoxItem>((variant: IInternalFontVariant) => {
                const { name, displayName, variantKey, disabled, tooltip, order } = variant;

                const item: IGroupedComboBoxItem = {
                    text: name,
                    displayText: displayName,
                    itemKey: variantKey,
                    icon: canPin ? emptyIconProps : undefined,
                    data: variant,
                    tooltip: tooltip,
                    onRenderIcon: canPin ? onRenderIcon : undefined,
                    onRenderLabel: renderPreviewFont,
                    disabled: disabled,
                    order: order,
                };

                if (canPin && (variant.$isPinned || pinnedFontKeys.includes(variantKey))) {
                    variant.$isPinned = true;
                    pinnedItems.push(createPinnedVariantItem(item));
                }

                variant.parentKey = variant.parentKey ?? font.fontKey;
                return item;
            }),
        },
    ];

    if (allowFontInfoPane && submenu.showFontInfoCommand) {
        sections.push({
            items: [
                {
                    text: stringResources.infoCommandLabel,
                    itemKey: fontInfoItemKey,
                    excludeFromSearch: true,
                    data: font,
                    tooltip: null, // disable tooltip
                },
            ],
        });
    }

    return sections;
}
